module.exports = __webpack_public_path__ + "static/media/share-icon-bg.b57f8945.svg";